import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanAllocationResponseDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlanAllocationRequest extends Request<never, InvestmentPlanAllocationResponseDTO> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/allocation`
    });
  }

  public execute(): Observable<InvestmentPlanAllocationResponseDTO> {
    return super
      .execute()
      .pipe(map((response: HttpResponse<InvestmentPlanAllocationResponseDTO>) => response.body));
  }
}

export function getInvestmentPlanAllocation(
  options?: RequestOptions<never>
): InvestmentPlanAllocationRequest {
  return new InvestmentPlanAllocationRequest(options);
}
